import { table } from './_table';

export const general = {
  namespaced: true,
  modules: {
    table
  }
};
